import React, { useState } from 'react'
import { FaPen } from 'react-icons/fa'

// editable only matters for a match that isn't decided yet — the master
// gets score inputs, a spectator just sees "vs". Byes never need either
// (already auto-decided the instant the round was generated). A decided
// match can still be reopened by the master via "editing" — for a
// knockout, that may flip who advanced, which discards and regenerates
// whatever later rounds were built on top of it (server-side), so we warn
// before sending it.
const TournamentMatch = ({ match, editable, onSubmit }) => {
  const [scoreA, setScoreA] = useState('')
  const [scoreB, setScoreB] = useState('')
  const [editing, setEditing] = useState(false)

  const isBye = match.teamB === null
  const decided = match.scoreA !== null

  const startEditing = () => {
    setScoreA(String(match.scoreA))
    setScoreB(String(match.scoreB))
    setEditing(true)
  }

  const submit = () => {
    const a = Number(scoreA)
    const b = Number(scoreB)
    if (scoreA === '' || scoreB === '' || !Number.isInteger(a) || !Number.isInteger(b) || a < 0 || b < 0) return
    if (decided && !window.confirm('Editar esse placar pode mudar quem avança e apagar rodadas seguintes já geradas a partir dele. Confirmar?')) {
      return
    }
    onSubmit(match.id, a, b)
    setEditing(false)
  }

  return (
    <div className="tournament-match">
      <span className={`tournament-match-team${match.winner === match.teamA ? ' winner' : ''}`}>{match.teamA}</span>

      {isBye ? (
        <span className="tournament-match-bye">bye</span>
      ) : decided && !editing ? (
        <span className="tournament-match-score">
          {match.scoreA} × {match.scoreB}
          {editable && (
            <button
              type="button"
              className="tournament-match-edit"
              onClick={startEditing}
              aria-label="Editar placar"
              title="Editar placar"
            >
              <FaPen />
            </button>
          )}
        </span>
      ) : editable ? (
        <div className="tournament-match-score">
          <input
            type="number"
            min="0"
            value={scoreA}
            onChange={(e) => setScoreA(e.target.value)}
            aria-label={`Placar de ${match.teamA}`}
          />
          <span>×</span>
          <input
            type="number"
            min="0"
            value={scoreB}
            onChange={(e) => setScoreB(e.target.value)}
            aria-label={`Placar de ${match.teamB}`}
          />
          <button type="button" onClick={submit} disabled={scoreA === '' || scoreB === ''}>
            OK
          </button>
        </div>
      ) : (
        <span className="tournament-match-score">vs</span>
      )}

      {!isBye && (
        <span className={`tournament-match-team${match.winner === match.teamB ? ' winner' : ''}`}>{match.teamB}</span>
      )}
    </div>
  )
}

export default TournamentMatch
